import { RecipeType } from '../enums/RecipeType';
import { MultifocalInfo } from './MultifocalInfo';
import { SaveDiagnosticInformationInputBase } from './SaveDiagnosticInformationInputBase';

export class SaveRecipeInputBase {
  pathToFile: string;
  recipeIsApproved: boolean = false;
  nasoPupillaryDistanceIsApproved: boolean = false;
  userId?: number|null;
  diagnosticInformations: SaveDiagnosticInformationInputBase[] = [];
  multifocalInfo?: MultifocalInfo | null;
  recipeType?: RecipeType;
  leftEyeHeight?: number|null;
  rightEyeHeight?: number|null;
}